import React from 'react';
import logoWidr from "../img/optovision_Logo_WIDRme_web.png";

const LogoWidr = () => (
    <img className='logo-ov-widr' src={logoWidr} width='142px' alt=""/>
);

export default LogoWidr;
